import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlaybooksState } from './state';

export const PlaybooksFeature = 'PlaybooksFeature';

export const PlaybooksFeatureStateSelector =
  createFeatureSelector<PlaybooksState>(PlaybooksFeature);

export const selectPlaybooks = createSelector(
  PlaybooksFeatureStateSelector,
  (state: PlaybooksState) => state.playbooks,
);

export const selectPlaybooksLoading = createSelector(
  PlaybooksFeatureStateSelector,
  (state: PlaybooksState) => state.loadingPlaybooks,
);

export const selectDeletingPlaybooks = createSelector(
  PlaybooksFeatureStateSelector,
  (state: PlaybooksState) => state.deletingPlaybooks,
);

export const selectLastUpdatedPlaybook = createSelector(
  PlaybooksFeatureStateSelector,
  (state: PlaybooksState) => state.lastUpdatedPlaybook,
);

export const selectPlaybooksBulkDeleteProcessing = selectDeletingPlaybooks;

export const fromPlaybooks = {
  selectPlaybooks,
  selectPlaybooksLoading,
  selectDeletingPlaybooks,
  selectLastUpdatedPlaybook,
  selectPlaybooksBulkDeleteProcessing,
};
